import { render, staticRenderFns } from "./LoginLogo.vue?vue&type=template&id=9fc8c16a"
var script = {}
import style0 from "./LoginLogo.vue?vue&type=style&index=0&id=9fc8c16a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports